import { render, staticRenderFns } from "./AttributeSelectRow.vue?vue&type=template&id=35cdf8d4&scoped=true"
import script from "./AttributeSelectRow.vue?vue&type=script&lang=ts&setup=true"
export * from "./AttributeSelectRow.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./AttributeSelectRow.vue?vue&type=style&index=0&id=35cdf8d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cdf8d4",
  null
  
)

export default component.exports